<template>
    <section>
        <div class="row justify-content-center">
            <div class="col-12 py-4">
                <h3 class="font-weight-bold text-center mb-3">
                    {{ product.name }}
                </h3>
                <div class="row justify-content-center">
                    <!--<div class="col-auto">
                        <h4 class="font-weight-bold">Cabang Utama:</h4>
                        <p class="mb-2">
                            <ul class="mb-0 pl-3 font-weight-medium">
                                <li v-for="branch in primaryBranches">{{ branch.name }}</li>
                            </ul>  
                        </p>
                    </div>
                    <div class="col-auto">
                        <h4 class="font-weight-bold">Cabang Mitra:</h4>
                        <p class="mb-2">
                            <ul class="mb-0 pl-3 font-weight-medium">
                                <li v-for="branch in partnerBranches">{{ branch.name }}</li>
                            </ul>  
                        </p>
                    </div>
                    <div class="col-auto">
                        <h4 class="font-weight-bold">Cabang PP:</h4>
                        <p class="mb-2">
                            <ul class="mb-0 pl-3 font-weight-medium">
                                <li v-for="branch in otherBranches">{{ branch.name }}</li>
                            </ul>  
                        </p>
                    </div>-->
                </div>
            </div>
            <div class="col-12" ref="registration">
                <form v-on:submit.prevent="save">
                    <div class="row justify-content-center">
                        <transition name="fade">
                            <section v-if="section === 1" class="col-md-4">
				<p> <strong>Jika asal sekolah tidak ada dalam pilihan, bisa memilih asal sekolah "SMA -" terlebih dahulu <br><br> Pastikan alamat email anda benar dan aktif untuk menerima konfirmasi selanjutnya.</strong> </p>
                                <div class="card shadow-sm mb-5 border-0">
                                    <div class="card-header background-primary">
                                        <div class="row">
                                            <div class="col text-center">
                                                <span class="h4 font-weight-medium text-white mb-0">
                                                    Profil Siswa *
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="card-body">
                                        <div class="row mb-1 align-items-center">
                                            <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                                <label class="font-weight-medium text-muted mb-0 h4 form-divider required">Nama Lengkap</label>
                                            </div>
                                            <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                                <input v-model="form.student.name" class="form-control form-control-sm" required />
                                            </div>
                                        </div>
                                        <div class="row mb-1 align-items-center">
                                            <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                                <label class="font-weight-medium text-muted mb-0 h4 form-divider required">Alamat Email</label>
                                            </div>
                                            <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                                <input v-model="form.student.email" type="email" class="form-control form-control-sm" required />
                                            </div>
                                        </div>
                                        <div class="row mb-1 align-items-center">
                                            <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                                <label class="font-weight-medium text-muted mb-0 h4 form-divider required">Asal Sekolah</label>
                                            </div>
                                            <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                                <multiselect v-model="school" v-on:select="school => form.student.schoolID = school.id" v-bind:options="schools" v-bind:allow-empty="false" tag-placeholder="" select-label="" label="name" track-by="id" placeholder="Asal Sekolah" class="form-control form-control-sm" required>
                                                </multiselect>
                                            </div>
                                        </div>
                                        <div class="row mb-1 align-items-center">
                                            <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                                <label class="font-weight-medium text-muted mb-0 h4 form-divider required">Prodi Sekolah</label>
                                            </div>
                                            <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                                <select v-model="form.student.gradeID" class="form-control form-control-sm" required>
                                                    <option disabled value="">Pilih Prodi Sekolah...</option>
                                                    <option v-for="grade in grades" v-bind:value="grade.id" v-bind:key="grade.id">{{ grade.name }}</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="row mb-1 align-items-center">
                                            <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                                <label class="font-weight-medium text-muted mb-0 h4 form-divider required">Prodi BTA</label>
                                            </div>
                                            <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                                <select v-model="form.student.btaGradeID" class="form-control form-control-sm" required>
                                                    <option disabled value="">Pilih Prodi BTA...</option>
                                                    <option v-for="grade in grades" v-bind:value="grade.id" v-bind:key="grade.id">{{ grade.name }}</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="row mb-1 align-items-center" v-for="attribute in ['tempat_lahir']">
                                            <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                                <label class="font-weight-medium text-muted mb-0 h4 form-divider">{{ humanize(attribute) }}</label>
                                            </div>
                                            <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                                <input v-model="form.profile[attribute]" class="form-control form-control-sm"  />
                                            </div>
                                        </div>
                                        <div class="row mb-1 align-items-center">
                                            <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                                <label class="font-weight-medium text-muted mb-0 h4 form-divider required">Tanggal Lahir</label>
                                            </div>
                                            <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                                <datepicker v-model="form.profile.tanggal_lahir" v-bind:language="dateLanguage" full-month-name monday-first clear-button v-bind:disabled-dates="{from: new Date}" input-class="form-control form-control-sm" required ></datepicker>
                                            </div>
                                        </div>
                                        <div class="row mb-1 align-items-center">
                                            <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                                <label class="font-weight-medium text-muted mb-0 h4 form-divider required">Jenis Kelamin</label>
                                            </div>
                                            <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                                <div class="form-check form-check-inline py-1" v-for="gender in ['Laki-laki', 'Perempuan']">
                                                    <div class="custom-control custom-radio">
                                                        <input v-model="form.profile.jenis_kelamin" type="radio" class="custom-control-input" v-bind:value="gender" v-bind:id="'input-jenis_kelamin-' + gender" />
                                                        <label class="custom-control-label h4" v-bind:for="'input-jenis_kelamin-' + gender">{{ gender }}</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row mb-1 align-items-center" v-for="attribute in ['alamat_rumah', 'kode_pos', 'nomor_telp_rumah', 'nomor_hp_siswa']">
                                            <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                                <label class="font-weight-medium text-muted mb-0 h4 form-divider">{{ humanize(attribute) }}</label>
                                            </div>
                                            <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                                <input v-model="form.profile[attribute]" class="form-control form-control-sm"  />
                                            </div>
                                        </div>
					
                                    </div>
                                </div>

                                <div class="row justify-content-center">
                                    <div class="col-sm-4">
                                        <router-link v-bind:to="{name: 'product/index'}" class="btn btn-sm btn-outline-danger btn-block">
                                            Cancel
                                        </router-link>
                                    </div>
                                    <div class="col-sm-4">
                                        <button type="submit" class="btn btn-sm btn-danger btn-block" v-on:click="$refs.registration.scrollIntoView();">
                                            Next
                                        </button>
                                    </div>
                                </div>
                            </section>
                        </transition>

                        <transition name="fade">
                            <section v-if="section === 2" class="col-md-4">
                                <div class="card shadow-sm mb-4 border-0">
                                    <div class="card-header background-primary">
                                        <div class="row">
                                            <div class="col text-center">
                                                <span class="h4 font-weight-medium text-white mb-0">
                                                    Data Orang Tua Siswa *
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="card-body">
                                        <div class="row mb-1 align-items-center" v-for="attribute in ['nama_ayah', 'nomor_hp_ayah', 'pekerjaan_ayah', 'nama_ibu', 'nomor_hp_ibu', 'pekerjaan_ibu']">
                                            <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                                <label class="font-weight-medium text-muted mb-0 h4 form-divider">{{ humanize(attribute) }}</label>
                                            </div>
                                            <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                                <input v-model="form.profile[attribute]" class="form-control form-control-sm"   required />
                                            </div>
                                        </div>
					<div class="row mb-1 align-items-center" v-for="attribute in [ 'email_ayah', 'email_ibu']">
                                            <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                                <label class="font-weight-medium text-muted mb-0 h4 form-divider">{{ humanize(attribute) }}</label>
                                            </div>
                                            <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                                <input v-model="form.profile[attribute]" class="form-control form-control-sm"  type="email"  required />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row justify-content-center">
                                    <div class="col-sm-4">
                                        <button type="button" class="btn btn-sm btn-outline-danger btn-block" v-on:click="section = 1; $refs.registration.scrollIntoView();">
                                            Back
                                        </button>
                                    </div>
                                    <div class="col-sm-4">
                                        <button type="submit" class="btn btn-sm btn-danger btn-block" v-on:click="$refs.registration.scrollIntoView();">
                                            Next
                                        </button>
                                    </div>
                                </div>
                            </section>
                        </transition>

                        <transition name="fade">
                            <section v-if="section === 3" class="col-md-4">
				<div class="col">
                   <img src="/static/images/page/about/tatib_2024.png" width="100%" height="auto" />
                            	    </div>
                                <div class="card shadow-sm mb-4 border-0">
				    
                                    <div class="card-header background-primary">
                                        <div class="row">
                                            <div class="col">
                                                <span class="h4 font-weight-medium text-white mb-0">
                                                    Data Kepesertaan Siswa BTA
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="card-body">
                                        <div class="row mb-1 align-items-center">
                                            <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                                <label class="font-weight-medium text-muted h4 mb-0 form-divider required">Tanggal Daftar</label>
                                            </div>
                                            <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                                <datepicker v-model="form.student.registeredAt" v-bind:language="dateLanguage" full-month-name monday-first clear-button v-bind:disabled-dates="{from: new Date, to: $moment().subtract(1, 'day').toDate()}" input-class="form-control form-control-sm" required></datepicker>
                                            </div>
                                        </div>
                                        <div class="row mb-1 align-items-center">
                                            <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                                <label class="font-weight-medium text-muted h4 mb-0 form-divider required">Cabang</label>
                                            </div>
                                            <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                                <select v-model="form.student.branchID" class="form-control form-control-sm" required>
                                                    <option disabled value="">Pilih Cabang...</option>
                                                    <option v-for="branch in product.branches" v-bind:value="branch.id" v-bind:key="branch.id">{{ branch.name }}</option>
                                                </select>
                                            </div>
                                        </div>
					<!--<div class="row mb-1 align-items-center">
                                        <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                            <label class="font-weight-medium text-muted mb-0 h4 form-divider">Program</label>
                                        </div>
                                        <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                            <select v-model="form.student.branchProgramID" class="form-control form-control-sm">
                                                <option value="">Pilih Program...</option>
                                                <option v-for="branchProgram in product.branchPrograms" v-bind:value="branchProgram.id" v-bind:key="branchProgram.id">{{ branchProgram.grade.name }} - {{ branchProgram.programType.name }}</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="row mb-1 align-items-center">
                                        <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                            <label class="font-weight-medium text-muted mb-0 h4 form-divider">Pola Semester 1</label>
                                        </div>
                                        <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                            <select v-model="form.verified.patternID" class="form-control form-control-sm">
                                                <option value="">Pilih Pola...</option>
                                                <option v-for="pattern in patterns" v-bind:value="pattern.id" v-bind:key="pattern.id">{{ patternLabel(pattern) }}</option>
                                            </select>
                                        </div>
                                    </div>-->
				    <div class="row mb-1 align-items-center">
                                        <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                            <label class="font-weight-medium text-muted mb-0 h4 form-divider required">Rencana Pola Hari</label>
                                        </div>
                                        <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                            <input v-model="form.verified.paymentNote" class="form-control form-control-sm" required />
                                        </div>
                                    </div>
				    <div class="row mb-1 align-items-center" v-for="attribute in [ 'pembelajaran']">
                                            <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                                <label class="font-weight-medium text-muted mb-0 h4 form-divider">{{ humanize(attribute) }}</label>
                                            </div>
                                            <div class="col-lg-7 col-md-12 col-sm-7 px-1">
						<div class="form-check form-check-inline py-1" v-for="learn in ['Online', 'Offline']">
                                                    <div class="custom-control custom-radio">
                                               		 <input v-model="form.profile[attribute]" type="radio" class="custom-control-input" v-bind:value="learn" v-bind:id="'input-pembelajaran-' + learn" />
							<label class="custom-control-label h4" v-bind:for="'input-pembelajaran-' + learn">{{ learn }}</label>
                                                    </div>
                                                </div>
                                            </div>
                                    </div>
				    <div class="row mb-1 align-items-center">
                                        <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                            <label class="font-weight-medium text-muted mb-0 h4 form-divider">Tahapan Pembayaran</label>
                                        </div>
					<div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                                <div class="form-check form-check-inline py-1" v-for="pay in ['Lunas', 'Bertahap 2x', 'Bertahap 3x', 'Lainnya']">
                                                    <div class="custom-control custom-radio">
                                                        <input v-model="form.verified.payment" type="radio" class="custom-control-input" v-bind:value="pay" v-bind:id="'input-bayar-' + pay" />
                                                        <label class="custom-control-label h4" v-bind:for="'input-bayar-' + pay">{{ pay }}</label>
                                                    </div>
                                                </div>
                                        </div>
                                        <!--<div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                            <input  v-model="form.verified.paymentNote" type="radio" class="form-control form-control-sm" />
						<label for="lunas">LUNAS</label><br>
                                        </div>-->
                                    </div>
					<div class="row mb-1 align-items-center" v-for="attribute in ['Mandiri_3_nomor']">
                                            <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                                <label class="font-weight-medium text-muted mb-0 h4 form-divider">Kode Referensi (Jika Ada)</label>
                                            </div>
                                            <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                                <input v-model="form.profile[attribute]" class="form-control form-control-sm" />
                                            </div>
                                        </div>
                                        <div class="row mb-1 align-items-center" v-for="attribute in ['ukuran_jaket']">
                                            <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                                <label class="font-weight-medium text-muted mb-0 h4 form-divider">Ukuran Jaket Khusus Kelas 12 & Alumni</label>
                                            </div>
                                            <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                                <input v-model="form.profile[attribute]" class="form-control form-control-sm" />
                                            </div>
                                        </div>
                                        <div class="row mb-1 align-items-center" v-for="n in 3">
                                            <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                                <label class="font-weight-medium text-muted mb-0 h4 form-divider">Sekolah/ Universitas Impian {{ n }}</label>
                                            </div>
                                            <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                                <input v-model="form.profile['sekolah_impian_' + n]" class="form-control form-control-sm"   />
                                            </div>
                                        </div>
                                    </div>
                                </div>
				<label class="font-weight-medium text-muted d-block">Saya telah membaca, mengerti, dan menaati tata tertib BTA Group tersebut. <br>Semua pembayaran yang telah dibayarkan, tidak dapat dikembalikan dengan alasan dan bentuk apapun.
 <input type="checkbox" id="myCheck" name="test" required></label>
                                

                                <div class="row justify-content-center">
                                    <div class="col-sm-4">
                                        <button type="button" class="btn btn-sm btn-outline-danger btn-block" v-on:click="section = 2; $refs.registration.scrollIntoView();">
                                            Back
                                        </button>
                                    </div>
                                    <div class="col-sm-4">
                                        <button type="submit" class="btn btn-sm btn-danger btn-block">
                                            Finish
                                        </button>
                                    </div>
                                </div>
                            </section>
                        </transition>

                        <transition name="fade">
                            <section v-if="section === 4" class="col-md-8">
                                <h1 class="font-weight-bold text-danger text-uppercase text-center mb-4">Selamat Data Proses Pendaftaran Anda Sudah Kami Terima!</h1>
                                <h3 class="font-weight-medium mb-5 text center"  >
                                    Untuk informasi selanjutnya akan disampaikan kemudian melalui nomor HP atau e-mail yang sudah didaftarkan
                                </h3>
                            </section>
                        </transition>
                    </div>
                </form>
            </div>
        </div>
    </section>
</template>

<script>
    import Multiselect from 'vue-multiselect';
    import Datepicker from 'vuejs-datepicker';
    import { id } from 'vuejs-datepicker/dist/locale';

    export default {
        name: "ProductRegistration",
        components: {
            Multiselect,
            Datepicker
        },
        computed: {
            primaryBranches() {
                return this.product.branches.filter(branch => branch.isPrimary);
            },
            partnerBranches() {
                return this.product.branches.filter(branch => !branch.isPrimary && !branch.isHidden);
            },
            otherBranches() {
                return this.product.branches.filter(branch => !branch.isPrimary && branch.isHidden);
            }
        },
	
        data() {
            return {
                form: {
                    student: {
                        name: '', email: '', schoolID: '', gradeID: '', btaGradeID: '', registeredAt: '', branchID: '', productID: ''
                    },
                    profile: {
                        tempat_lahir: '', tanggal_lahir: '', jenis_kelamin: 'Laki-laki', alamat_rumah: '', kode_pos: '', nomor_telp_rumah: '', nomor_hp_siswa: '', pembelajaran: 'Online',
                        nama_ayah: '', nomor_hp_ayah: '', pekerjaan_ayah: '', email_ayah: '', nama_ibu: '', nomor_hp_ibu: '', pekerjaan_ibu: '', email_ibu: '',
                        ukuran_jaket: '', sekolah_impian_1: '', sekolah_impian_2: '', sekolah_impian_3: ''
                    },
                    verified: {
                        patternID: '', branchClassID: '', secondPatternID: '', secondBranchClassID: '', payment: 'Lunas', paymentNote: '', placement: '', intensiveScheduleID: '', intensiveClassID: ''
                    }
                },
                school: null,
                grades: [],
                schools: [],
		branchProgramID: '',
                branches: [],
                patterns: [],
                section: 1,
                maxSection: 3,
                dateLanguage: id,
                product: {branches: []}
            };
        },
        methods: {
            save() {
                if (this.section >= this.maxSection) {
                    this.form.student.productID = this.product.id;
                    if (this.form.student.registeredAt) {
                        this.form.student.registeredAt = this.$moment(this.form.student.registeredAt).format('YYYY-MM-DD');
                    }
                    this.axios.post(process.env.API_URL + '/site/register', this.form).then(response => {
                        if (response.data.status) {
                            this.$toastr('success', response.data.message, 'Success');

                            this.section++;
                            this.$refs.registration.scrollIntoView();
                        } else {
                            this.$toastr('warning', response.data.errors[Object.keys(response.data.errors)[0]][0], 'Warning');
                        }
                    });
                } else {
                    this.section++;
                }
            },
	    patternLabel(pattern) {
                return pattern.periods.map(period => {
                    return this.$moment.weekdays(period.day) + ' ' + this.$moment(period.start, "HH:mm:ss").format('HH.mm') + ' - ' + this.$moment(period.end, "HH:mm:ss").format('HH.mm');
                }).join(" | ");
            },
	
            humanize(string) {
                return string.replace(/[_]+/g, ' ').replace(/^[a-z]| [a-z]/g, function (character) {
                    return character.toUpperCase();
                });
            }
        },
        created() {
            this.axios.all([
                this.axios.get(process.env.API_URL + '/product/' + this.$route.params.id),
                this.axios.get(process.env.API_URL + '/grade'),
                this.axios.get(process.env.API_URL + '/school')
            ]).then(this.axios.spread(function (responseProduct, responseGrade, responseSchool) {
                this.product = responseProduct.data.data;
                this.grades = responseGrade.data.data;
                this.schools = responseSchool.data.data;
            }.bind(this)));
        },
        mounted() {
            document.title = 'Student Registration - ' + process.env.APP_NAME;
        }
    };
</script>

<style scoped>
    .fade-enter-active { transition: opacity .5s; }
    .fade-enter, .fade-leave-to, .fade-leave-active { opacity: 0; }
    .card-body { padding-left: 1.9rem; padding-right: 1.9rem; }
    @media (max-width: 991.98px) {
        .form-divider::before{ display: none; }
    }
</style>


// WEBPACK FOOTER //
// src/components/product/Registration.vue